import { UseMutationOptions, useMutation, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "../apiService";
import { VERSION_HISTORY_QUERY_KEYS } from "../../components/drawing-tool/version-history/constants/versionHistory.constants";
import {
  GroupedVersionHistoryParams,
  GroupedVersionHistoryResponse,
  UpdateVersionMetadataPayload,
  UpdateVersionMetadataResponse
} from "../../components/drawing-tool/version-history/types/versionHistory.types";

export const useGetGroupedVersionHistory = (
  params: Partial<GroupedVersionHistoryParams>,
  enabled: boolean
) =>
  useQuery<GroupedVersionHistoryResponse, ApiServiceErr>(
    [VERSION_HISTORY_QUERY_KEYS.groupedHistory, params.productId, params.salesUnitId, params.pageNumber, params.pageSize],
    async () => {
      const response = await axiosApi.get("/mapping-versions/history/grouped", { params });
      return response.data;
    },
    {
      enabled: enabled && !!params.productId && !!params.salesUnitId,
      keepPreviousData: true
    }
  );

export const useUpdateVersionMetadata = (
  opt?: UseMutationOptions<UpdateVersionMetadataResponse, ApiServiceErr, UpdateVersionMetadataPayload>
) =>
  useMutation<UpdateVersionMetadataResponse, ApiServiceErr, UpdateVersionMetadataPayload>(async ({ versionId, ...body }) => {
    const response = await axiosApi.patch(`/mapping-versions/${versionId}/metadata`, body);
    return response.data;
  }, opt);
